import React from 'react'
import styled from 'styled-components'
import { ButtonStyleProps, MarginProps, margin } from 'styled-system'

import { AdjustColorTint } from 'utils/colors'

import { Button, BaseButtonProps } from '../Button'

type TextButtonProps = BaseButtonProps &
  MarginProps & {
    children?: string | React.ReactNode
    isSubmitting?: boolean
    hoverEffect?: 'underline' | 'none'
    tooltipPosition?: 'top' | 'bottom' | 'left' | 'right' | 'bottomRight' | 'topRight' | 'topLeft' | 'bottomLeft'
  }

const TextButton = ({
  margin,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  marginX,
  marginY,
  m,
  mb,
  ml,
  mr,
  mt,
  mx,
  my,
  hoverEffect = 'none',
  tooltipPosition = 'right',
  ...props
}: TextButtonProps) => (
  <Container
    m={m || margin}
    mb={mb || marginBottom}
    ml={ml || marginLeft}
    mr={mr || marginRight}
    mt={mt || marginTop}
    mx={mx || marginX}
    my={my || marginY}
    inline={props.inline}
  >
    <StyledTextButton {...props} hoverEffect={hoverEffect} tooltipPosition={tooltipPosition} margin={0} />
  </Container>
)

const StyledTextButton = styled((p) => <Button {...p} />)<ButtonStyleProps>`
  height: fit-content;
  color: ${(p) => p.theme.colors[p.color] ?? p.theme.colors.blue1};
  padding: 0;

  &&& {
    svg {
      color: ${(p) => p.theme.colors[p.iconColor] ?? p.theme.colors[p.color] ?? p.theme.colors.blue1};
    }

    :hover {
      color: ${(p) => (p.theme.colors[p.color] ? AdjustColorTint(p.theme.colors[p.color], 10) : p.theme.colors.blue2)};
      text-decoration: ${(p) => p.hoverEffect};

      > svg {
        color: ${(p) =>
          p.theme.colors[p.iconColor] ? AdjustColorTint(p.theme.colors[p.iconColor], 10) : p.theme.colors.blue2};
      }
    }

    :active {
      color: ${(p) => (p.theme.colors[p.color] ? AdjustColorTint(p.theme.colors[p.color], 30) : p.theme.colors.blue4)};

      > svg {
        color: ${(p) =>
          p.theme.colors[p.iconColor] ? AdjustColorTint(p.theme.colors[p.iconColor], 30) : p.theme.colors.blue4};
      }
    }

    :disabled {
      color: ${(p) => p.theme.colors.gray5};

      > svg {
        color: ${(p) => p.theme.colors.gray5};
      }
    }
  }
`

const Container = styled.div<MarginProps & { inline?: boolean }>`
  ${margin}
  display: ${(p) => (p.inline ? 'inline-block' : 'block')};
`

export default TextButton
